// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wl-scroll{flex:1;height:100%}.wl-scroll>.el-scrollbar__wrap{overflow-x:hidden}", ""]);
// Exports
module.exports = exports;
